import IconButton from '@mui/material/IconButton';
import { useState  } from 'react';
import { OutlinedInput } from '@mui/material';
import { motion } from 'framer-motion';
import InputAdornment from '@mui/material/InputAdornment';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';


function SearchBox(props) {
  const { executeSearchFunction, placeholderText, value, className, sx } = props;
  const [currentTextVal, setCurrentTextVal] = useState(value ? value : "");
  const useClasses= className ? className : "flex flex-1 items-center px-16 rounded-full h-40 w-full sm:max-w-240 mb-10";

  function handleKeyPress(ev) {
	if(ev.charCode === 13){
	   executeSearchFunction(currentTextVal);
    }
  }

  return (
    <OutlinedInput
      component={motion.div}
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className={useClasses}
      placeholder={placeholderText}
      variant="outlined"
      fullWidth
      sx={sx}
      startAdornment={
        <InputAdornment position="start">
          <FuseSvgIcon color="disabled">heroicons-solid:search</FuseSvgIcon>
        </InputAdornment>
      }
      inputProps={{
        'aria-label': 'Search',
      }}
      value={currentTextVal}
      autoFocus
      onChange={(ev) => setCurrentTextVal(ev.target.value)}
      onKeyPress={(ev) => handleKeyPress(ev)}
    />
  );
}

SearchBox.propTypes = {};
SearchBox.defaultProps = {
  trigger: (
    <IconButton className="w-64 h-64" size="large">
      <FuseSvgIcon>heroicons-outline:search</FuseSvgIcon>
    </IconButton>
  ),
};

export default SearchBox;
